"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushOperateLog = void 0;
const user_1 = __importDefault(require("@/data/user"));
const system_1 = __importDefault(require("@/pages/index/api/system"));
const pushOperateLog = function (businessId, operate, method) {
    return system_1.default.operateLogBuild.require({
        businessId,
        operation: user_1.default.info.name + operate,
        method
    });
};
exports.pushOperateLog = pushOperateLog;
